import { type WidgetMetadata } from '@examdojo/core/widget';
import { ARITHMETIC_EXPLORATION_PRESET } from './presets';
import { ArithmeticSequenceWidgetConfig } from './arithmetic-sequence.model';

/**
 * Capability-focused metadata for the Arithmetic Sequence Widget.
 * Describes what the widget can do; presets provide example configs.
 */
export const ARITHMETIC_SEQUENCE_METADATA: WidgetMetadata<ArithmeticSequenceWidgetConfig> = {
  type: 'arithmetic-sequence',
  description: 'Interactive arithmetic sequence visualization u_n = a + (n-1)d',

  // Mathematical parameters
  parameters: ['a', 'd', 'numTerms'],

  // Display features that can be toggled
  displayFeatures: ['bars', 'points', 'connectingLine', 'termLabels', 'valueLabels', 'differenceArcs', 'grid', 'axes'],

  // Actions the widget supports
  supportedActions: [
    'UPDATE_PARAMS',
    'FIT_TO_SEQUENCE',
    'FOCUS_REGION',
    'HIGHLIGHT',
    'RESET_VIEW',
    'TRANSFORM_VIEW',
    'PATCH_STYLE',
  ],

  // Regions that can be focused/zoomed to
  focusableRegions: ['all', 'sequence', 'term-1', 'term-2', 'term-3'],

  // Object IDs that can be highlighted
  highlightableObjects: ['bar-1', 'bar-2', 'bar-3', 'bar-4', 'bar-5', 'bar-6', 'connecting-line'],

  // Presets serve as living documentation of valid configs
  exampleConfigs: [ARITHMETIC_EXPLORATION_PRESET.config],
};
